module.exports = __webpack_public_path__ + "img/tax-planning-intro.caa769c6.svg";